import dynamic from "next/dynamic";
import Image from "next/image";

import { Mail, MapPin, Phone } from "lucide-react";
import { email, phoneNumber } from "@/constants/home/contactData";

const ContactForm = dynamic(() => import("./common/ContactForm"), {
  ssr: false,
});

function ContactUs() {
  const contactInfo = [
    {
      title: "Write us at",
      value: email,
      icon: <Mail size={30} />,
    },
    {
      title: "Call us",
      value: `+91 ${phoneNumber}`,
      icon: <Phone size={30} />,
    },
    {
      title: "Address",
      value: "Sector 137, Noida - 201305",
      icon: <MapPin size={30} />,
    },
  ];

  return (
    <section id="contact" className="relative py-10">
      <Image
        src="/assets/background-image/bg-invi.webp"
        width={1000}
        height={1000}
        alt="photography"
        className="absolute w-full h-full object-cover top-0 left-0 z-[1]"
      />
      <div className="relative z-[2]">
        <h2 className="font-Jost text-center text-6xl font-extralight text-lightGray">
          Contact Us
        </h2>
        <p className="pt-10 tracking-[2.25px] text-lg lg:px-36 px-4 text-center">
          Have Questions? Feel Free to Write Us
        </p>
        <div className="grid grid-cols-12 lg:gap-20 lg:mx-36 mx-4 lg:my-20 my-10">
          <div className="lg:col-span-6 col-span-12">
            <h3 className=" lg:text-2xl text-xl font-semibold lg:text-left text-center mx-2 lg:mx-0">
              Have Questions? Feel Free to Write Us
            </h3>
            <p className="py-4 tracking-[2.25px] lg:text-lg text-base lg:text-left text-center">
              If you have any questions or inquiries, we are here to help! We
              value your feedback and are eager to assist you.
            </p>
            {contactInfo.map((contact, index) => {
              return (
                <div key={index} className="flex items-center mt-10">
                  <span className="bg-white text-lightGray p-4 text-6xl shadow-blr-box rounded-md mr-4">
                    {contact.icon}
                  </span>
                  <div>
                    <h4 className="text-base ">{contact.title}</h4>
                    <span className="text-xl font-semibold">
                      {contact.value}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="lg:col-span-6 col-span-12">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
